import { useEffect, useState } from 'react';
import InstallPrompt from './InstallPrompt';
import { canShowInstallPrompt } from '../utils/pwaInstall';

// Mounted once at the app root (App.tsx) so the install prompt can surface on
// ANY route — the landing page, invitation links like /auth/register, the
// mobile field flow, etc. Most users reach the app via a deep link rather
// than `/`, so the trigger can't live in a single layout.
//
// Wait ~1.5s so Android Chrome has time to fire beforeinstallprompt; iOS
// Safari never fires it but canShowInstallPrompt() still returns true so the
// dialog renders the Share -> Add-to-Home-Screen coach mark. Already-installed
// (standalone) detection and the 30-day dismissal cooldown live inside
// canShowInstallPrompt(), so this never nags an installed or recently-dismissed
// user.
export default function InstallPromptManager() {
  const [showInstall, setShowInstall] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => {
      if (canShowInstallPrompt()) setShowInstall(true);
    }, 1500);
    return () => clearTimeout(id);
  }, []);

  return <InstallPrompt open={showInstall} onClose={() => setShowInstall(false)} />;
}
